import { render, staticRenderFns } from "./WeddingCommission.vue?vue&type=template&id=b4bf2b52&scoped=true"
import script from "./WeddingCommission.vue?vue&type=script&lang=js"
export * from "./WeddingCommission.vue?vue&type=script&lang=js"
import style0 from "./WeddingCommission.vue?vue&type=style&index=0&id=b4bf2b52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf2b52",
  null
  
)

export default component.exports